import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=c732d53a&scoped=true"
import script from "./UserSettings.vue?vue&type=script&lang=ts"
export * from "./UserSettings.vue?vue&type=script&lang=ts"
import style0 from "./UserSettings.vue?vue&type=style&index=0&id=c732d53a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c732d53a",
  null
  
)

export default component.exports